import React from "react";
import "./Skills.css";
import {
  SiAstro,
  SiCss3,
  SiHtml5,
  SiJavascript,
  SiNuxtdotjs,
  SiPhp,
  SiSvelte,
  SiTailwindcss,
  SiVuedotjs,
  SiTypescript,
  SiReact,
  SiNodedotjs,
  SiExpress,
  SiPrisma,
  SiAppwrite,
  SiFastify,
  SiSass,
  SiGooglemaps,
} from "react-icons/si";
import {
  FaCode,
  FaLaptopCode,
  FaServer,
  FaStar,
} from "react-icons/fa";

const Skills = () => {
  const skillCategories = [
    {
      id: "featured",
      title: "Featured",
      icon: <FaStar />,
      skills: [
        { name: "Astro", icon: <SiAstro /> },
        { name: "CSS", icon: <SiCss3 /> },
        { name: "HTML", icon: <SiHtml5 /> },
        { name: "JavaScript", icon: <SiJavascript /> },
        { name: "Nuxt", icon: <SiNuxtdotjs /> },
        { name: "PHP", icon: <SiPhp /> },
        { name: "Svelte", icon: <SiSvelte /> },
        { name: "Tailwind CSS", icon: <SiTailwindcss /> },
        { name: "Vue", icon: <SiVuedotjs /> },
      ],
    },
    {
      id: "languages",
      title: "Languages",
      icon: <FaCode />,
      skills: [
        { name: "CSS", icon: <SiCss3 /> },
        { name: "HTML", icon: <SiHtml5 /> },
        { name: "JavaScript", icon: <SiJavascript /> },
        { name: "PHP", icon: <SiPhp /> },
        { name: "TS", icon: <SiTypescript /> },
        { name: "TypeScript", icon: <SiTypescript /> },
      ],
    },
    {
      id: "frontend",
      title: "Frontend",
      icon: <FaLaptopCode />,
      skills: [
        { name: "Astro", icon: <SiAstro /> },
        { name: "Google Maps", icon: <SiGooglemaps /> },
        { name: "Nuxt", icon: <SiNuxtdotjs /> },
        { name: "React", icon: <SiReact /> },
        { name: "SASS", icon: <SiSass /> },
        { name: "Svelte", icon: <SiSvelte /> },
        { name: "SvelteKit", icon: <SiSvelte /> },
        { name: "Tailwind CSS", icon: <SiTailwindcss /> },
        { name: "Vue", icon: <SiVuedotjs /> },
      ],
    },
    {
      id: "backend",
      title: "Backend",
      icon: <FaServer />,
      skills: [
        { name: "Appwrite", icon: <SiAppwrite /> },
        { name: "Express", icon: <SiExpress /> },
        { name: "Fastify", icon: <SiFastify /> },
        { name: "Lucia", icon: <FaServer /> },
        { name: "Node.js", icon: <SiNodedotjs /> },
        { name: "Prisma", icon: <SiPrisma /> },
      ],
    },
  ];

  return (
    <section className="skills">
      <div className="skills-container">
        <h1 className="page-title">Skills</h1>
        <div className="skills-wrapper">
          {skillCategories.map((category) => (
            <div className="skill-category-card" key={category.id}>
              <div className="category-header">
                <span className="category-icon">{category.icon}</span>
                <h2>{category.title}</h2>
              </div>
              <div className="skill-tags">
                {category.skills.map((skill, index) => (
                  <div className="skill-tag" key={index}>
                    <span className="skill-tag-icon">{skill.icon}</span>
                    {skill.name}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;